const registrations = new Map();
const listeners = new Set();

let pendingExit = null;
let isRevertingHash = false;

function notify() {
  for (const listener of listeners) {
    listener(getGenerationNavigationGuardState());
  }
}

export function subscribeGenerationNavigationGuard(listener) {
  listeners.add(listener);
  listener(getGenerationNavigationGuardState());
  return () => listeners.delete(listener);
}

export function getGenerationNavigationGuardState() {
  return {
    isActive: registrations.size > 0,
    activeTools: [...registrations.values()],
    pendingExit,
  };
}

export function registerGenerationActivity(toolId, active, meta = {}) {
  if (!toolId) {
    return;
  }

  if (active) {
    registrations.set(toolId, { toolId, ...meta });
  } else {
    registrations.delete(toolId);
  }
  notify();
}

export function isGenerationNavigationBlocked() {
  return registrations.size > 0;
}

export function getPrimaryActiveGeneration() {
  const values = [...registrations.values()];
  return values.length > 0 ? values[values.length - 1] : null;
}

export function requestGenerationExitConfirmation(request) {
  pendingExit = request;
  notify();
}

export function confirmGenerationExit(onConfirm) {
  if (!isGenerationNavigationBlocked()) {
    onConfirm();
    return;
  }

  requestGenerationExitConfirmation({
    type: "action",
    onConfirm,
  });
}

export function confirmPendingGenerationExit() {
  const request = pendingExit;
  pendingExit = null;
  registrations.clear();
  notify();

  if (!request) {
    return;
  }

  if (request.type === "navigate") {
    if (request.onNavigate) {
      request.onNavigate(request.targetHash);
    }
    return;
  }

  request.onConfirm?.();
}

export function cancelPendingGenerationExit() {
  pendingExit = null;
  notify();
}

export function markHashRevertInProgress() {
  isRevertingHash = true;
}

export function consumeHashRevertFlag() {
  if (!isRevertingHash) {
    return false;
  }
  isRevertingHash = false;
  return true;
}

export function resetGenerationNavigationGuardForTests() {
  registrations.clear();
  pendingExit = null;
  isRevertingHash = false;
  notify();
}
